import cx from 'classnames';

import s from './Item.module.css';

export interface ItemProps {
  className?: string;
  selected?: boolean;
  listView?: boolean;
  disabled?: boolean;
  title: string;
  image?: string;
  children: React.ReactNode;
  button: React.ReactNode;
}

type OverlayProps = {
  children: React.ReactNode;
};

const Overlay = ({ children, ...otherProps }: OverlayProps) => {
  return (
    <div className={cx(s.overlay)} {...otherProps}>
      {children}
    </div>
  );
};

export const Item = ({
  className,
  selected,
  disabled = false,
  listView = false,
  title,
  children,
  image,
  button,
}: ItemProps) => {
  return (
    <div
      className={cx(
        s.service,
        {
          [s.listView]: listView,
          [s.disabled]: disabled,
        },
        className,
      )}
    >
      <div
        className={cx(s.wrapper, {
          [s.selected]: selected,
        })}
        style={listView || !image ? {} : { backgroundImage: `url(${image})` }}
      >
        <div className={s.contentContainer}>
          <div className={s.content}>
            <div className={s.information}>
              <h3>{title}</h3>
              <div>{children}</div>
            </div>

            {button}
          </div>
        </div>

        <div className={s.outline} />
      </div>
    </div>
  );
};

Item.Overlay = Overlay;
